import {makeAutoObservable} from "mobx"

export interface DialogStoreInterface {
    dialogOpen: boolean
    dialogErrorMessage?: string
    executing: boolean
}

class DialogStore implements DialogStoreInterface {
    get executing(): boolean {
        return this._executing
    }

    set executing(value: boolean) {
        this._executing = value
    }
    get dialogErrorMessage(): string | undefined {
        return this._dialogErrorMessage
    }

    set dialogErrorMessage(value: string | undefined) {
        this._dialogErrorMessage = value
    }
    get dialogOpen(): boolean {
        return this._dialogOpen
    }

    set dialogOpen(value: boolean) {
        this._dialogOpen = value
    }
    private _dialogOpen: boolean = false
    private _dialogErrorMessage?: string | undefined
    private _executing: boolean = false

    constructor() {
        makeAutoObservable(this)
    }
}

export {
    DialogStore
}
